import { render, staticRenderFns } from "./TalksInfo.vue?vue&type=template&id=027d5f12&scoped=true&"
import script from "./TalksInfo.vue?vue&type=script&lang=ts&"
export * from "./TalksInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TalksInfo.vue?vue&type=style&index=0&id=027d5f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027d5f12",
  null
  
)

export default component.exports